import { render, staticRenderFns } from "./ButtonCategory.vue?vue&type=template&id=4f9b67e6&scoped=true"
import script from "./ButtonCategory.vue?vue&type=script&lang=js"
export * from "./ButtonCategory.vue?vue&type=script&lang=js"
import style0 from "./ButtonCategory.vue?vue&type=style&index=0&id=4f9b67e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b67e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f9b67e6')) {
      api.createRecord('4f9b67e6', component.options)
    } else {
      api.reload('4f9b67e6', component.options)
    }
    module.hot.accept("./ButtonCategory.vue?vue&type=template&id=4f9b67e6&scoped=true", function () {
      api.rerender('4f9b67e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/ButtonCategory.vue"
export default component.exports